import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Domain extends Component {
  state = {
    user_id: localStorage.getItem("user_id"),
    user_role: localStorage.getItem("user_role"),

    domain_name: "",
    theme_or_landing_status: "",

    loading: false,
  };

  // Handle text input
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // Copy DNS text
  handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Copied!",
          text: `${text} copied to clipboard.`,
          timer: 1500,
          showConfirmButton: false,
        });
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  // Fetch existing domain
  fetchExistingDomain = async () => {
    const { user_id, user_role } = this.state;
    if (!user_id || !user_role) return;

    try {
      this.setState({ loading: true });

      const res = await axios.get("/get_domain", {
        params: { user_id, user_role },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.data.data) {
        this.setState({
          domain_name: res.data.data.domain_name || "",
          theme_or_landing_status: res.data.data.theme_or_landing_status || "",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    this.fetchExistingDomain();
  }

  // Save or update domain
  handleSubmit = async (e) => {
    e.preventDefault();

    const { user_id, user_role, domain_name, theme_or_landing_status } = this.state;

    if (!user_id || !user_role) {
      Swal.fire("Error", "User ID or role not found", "error");
      return;
    }

    if (!domain_name) {
      Swal.fire("Error", "Domain Name is required", "error");
      return;
    }

    try {
      this.setState({ loading: true });

      const res = await axios.post(
        "/domains",
        {
          domain_name,
          theme_or_landing_status
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      Swal.fire("Success", res.data.message, "success");
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { domain_name, theme_or_landing_status, loading } = this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-4">
                  <form onSubmit={this.handleSubmit}>
                    <h4 className="fw-semibold text-uppercase text-center mb-3">
                      Add Custom Domain OR Sub Domain
                    </h4>

                    <div className="row g-3">
                      <div className="col-md-2"></div>
                      <div className="col-md-8">
                        <div className="card bg-primary">
                          <div
                            className="card-body"
                            style={{
                              backgroundColor: "#f9f8fe",
                              border: "1px solid #e1e1e1",
                              borderRadius: "15px",
                            }}
                          >
                            <h4 className="text-black">
                              <p className="fs-5">
                                <b>The Steps Below:</b>
                                <br />
                                1. Point A Record for @:{" "}
                                <b
                                  className="copyDNS"
                                  style={{ cursor: "pointer", color: "#0d6efd" }}
                                  onClick={() =>
                                    this.handleCopy("128.199.220.202")
                                  }
                                >
                                  128.199.220.202 <i className="ti ti-copy"></i>
                                </b>
                                <br />
                                2. Point CNAME Record for www:{" "}
                                <b>your_domain.com</b>
                              </p>
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2"></div>

                      {/* Domain Name */}
                      <div className="col-md-2"></div>
                      <div className="col-md-8">
                        <label className="form-label">
                          Domain Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="domain_name"
                          className="form-control"
                          placeholder="Enter Domain OR Sub Domain Name"
                          value={domain_name}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-2"></div>

                    </div>

                    <div className="text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary px-4"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>



                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Domain;
